'use client';

import React, { FC } from 'react';

import PartFeedback from '@/components/part-feedback';
import PartOrderSection from '@/components/part-order-section';
import PartPageBanner from '@/components/UI/part-page-banner';
import PartServicesDecor from '@/components/UI/part-services-decor';
import { IListCases } from '@/contentful/utils/cases';
import { IDivider } from '@/contentful/utils/divider';
import { IForm } from '@/contentful/utils/form';
import { useLanguage } from '@/context/LanguageContext';

import PartDescription from './part-description';
import PartOtherCases from './part-other-cases';

interface IPartServicesView {
  data: {
    casePage: IListCases[];
    dividers: IDivider[];
    listCases: IListCases[];
    forms: IForm[];
  };
}

const PageCaseView: FC<IPartServicesView> = ({ data }) => {
  const { language } = useLanguage();

  const casePage = data.casePage.filter((item) => item.lang === language)[0];

  const caseDividers = data.dividers.filter(
    (item) => item.lang === language,
  )[0];

  const casesList = data.listCases.filter((item) => item.lang === language);

  const casesListFiltered = casesList
    .filter((item) => item.filter.some((filterItem) => casePage.filter.includes(filterItem)))
    .filter((item) => item.slug !== casePage.slug)
    .slice(0, 3);

  const caseForm = data.forms.filter((item) => item.lang === language)[0];

  const casePageBannerData = {
    title: casePage.title,
    category: casePage.category,
    imageDesktop: casePage.imageBannerDesktop,
    imageMobile: casePage.imageBannerMobile,
  };

  const parentPage = [
    {
      text: 'Cases',
      href: language === 'lv' ? '/cases' : `/${language}/cases`,
    },
  ];

  const casePageDescription = {
    beforeImage: casePage.beforeImage,
    beforeText: casePage.beforeText,
    afterImage: casePage.afterImage,
    afterText: casePage.afterText,
    descriptionFeatures: casePage.descriptionFeatures,
  };

  const casePageDivider = {
    lang: language,
    title: caseDividers.title,
    description: caseDividers.description,
    buttonName: caseDividers.buttonName,
    slug: caseDividers.slug,
  };

  const otherCasesData = {
    lang: language,
    otherCasesCategory: casePage.otherCasesCategory,
    otherCasesTitle: casePage.otherCasesTitle,
    otherCases: casesListFiltered,
  };

  return (
    <>
      <PartPageBanner data={casePageBannerData} parentPage={parentPage} />
      <PartDescription data={casePageDescription} />
      <PartOrderSection data={casePageDivider} />
      <PartOtherCases data={otherCasesData} />
      <PartFeedback data={caseForm} />
      <PartServicesDecor />
    </>
  );
};

export default PageCaseView;
